/**
 * §31.2 riesgo B — aviso de expiración de sesión por inactividad, 5 MINUTOS ANTES
 * (no 30). Nace de la pantalla de cocina (pasiva, solo polling → el polling NO cuenta
 * como actividad; ver AuthProvider), pero aplica a toda la app: cualquier pantalla sin
 * tocar avisa antes de caerse en vez de cerrarse en seco.
 *
 * Lee la MISMA fuente que el logout por idle (getLastActivity + getIdleWindowMs); el
 * botón "Seguir conectado" hace touchActivity() (reinicia la ventana). Si el usuario
 * mueve el mouse, lastActivity se actualiza y el aviso se auto-oculta.
 */
import { useEffect, useState } from 'react';
import { getIdleWindowMs, getLastActivity, touchActivity } from '../lib/api';

const WARN_MS = 5 * 60 * 1000; // avisar cuando falten <= 5 min

export function SessionExpiryWarning() {
  const [msLeft, setMsLeft] = useState<number | null>(null);

  useEffect(() => {
    const compute = () => {
      const last = getLastActivity();
      if (!last) { setMsLeft(null); return; } // sin marca (sesión nueva/legacy) → no avisar
      const left = last + getIdleWindowMs() - Date.now();
      setMsLeft(left > 0 && left <= WARN_MS ? left : null);
    };
    compute();
    const id = window.setInterval(compute, 1000);
    return () => window.clearInterval(id);
  }, []);

  if (msLeft == null) return null;
  const m = Math.floor(msLeft / 60000);
  const s = Math.floor((msLeft % 60000) / 1000);

  return (
    <div className="fixed inset-x-0 bottom-4 z-[100] mx-auto w-[92%] max-w-md rounded-2xl border border-amber-300 bg-white p-4 shadow-xl">
      <p className="text-sm font-semibold text-slate-900">Tu sesión está por cerrarse</p>
      <p className="mt-1 text-xs text-slate-500">
        Por inactividad se cerrará en{' '}
        <b className="tabular-nums text-slate-700">{m}:{String(s).padStart(2, '0')}</b>. ¿Sigues ahí?
      </p>
      <button
        onClick={() => { touchActivity(); setMsLeft(null); }}
        className="mt-3 w-full rounded-xl bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800">
        Seguir conectado
      </button>
    </div>
  );
}
